const levels: string[] = [
    "Niveau 1",
    "Niveau 2",
    "Niveau 3",
    "Niveau 4"
]

export default levels